<template>
	<div>
		<b-form>
			<b-card>
				<b-card-header class="pt-0">
					<span class="h3">Input</span>
				</b-card-header>
				<b-card-body class="pb-0">
					<b-row>
						<b-col xl="12" lg="12" sm="12">
							<b-input-group class="mb-3" prepend="ICCID" label-for="iccidInfo" :state="iccidState">
								<b-form-input
									id="iccidInfo"
									placeholder="Ex: 89018101604000012172"
									:state="iccidState"
									v-model="addSubscriberForm.iccidInfo"
									trim
									readonly="readonly"
								></b-form-input>
								<b-form-invalid-feedback :state="iccidState">
									Please enter a valid iccid.
								</b-form-invalid-feedback>
							</b-input-group>

							<b-input-group prepend="IMSI" class="mb-3" label-for="imsiInfo" :state="imsiState">
								<b-form-input
									id="imsiInfo"
									placeholder="Ex: 311240000100019"
									:state="imsiState"
									v-model="addSubscriberForm.imsiInfo"
									trim
									readonly="readonly"
								></b-form-input>
								<b-form-invalid-feedback :state="imsiState">
									Please enter a valid imsi.
								</b-form-invalid-feedback>
							</b-input-group>

							<b-input-group prepend="MSISDN" class="mb-3" label-for="msisdnInfo" :state="msisdnState">
								<b-form-input
									id="msisdnInfo"
									placeholder="Ex: 18889990000"
									:state="msisdnState"
									v-model="addSubscriberForm.msisdnInfo"
									trim
								></b-form-input>
								<b-form-invalid-feedback :state="msisdnState">
									Please enter a valid 11 digit msisdn.
								</b-form-invalid-feedback>
							</b-input-group>

							<b-input-group
								prepend="MIN"
								class="mb-3"
								label-for="msisdnInfo"
								v-if="hasMin"
								:state="minState"
							>
								<b-form-input
									id="minInfo"
									placeholder="Ex: 8889990000"
									:state="minState"
									v-model="addSubscriberForm.minInfo"
									trim
								></b-form-input>
								<b-form-invalid-feedback :state="minState">
									Please enter a valid 10 digit min.
								</b-form-invalid-feedback>
							</b-input-group>

							<b-input-group
								prepend="Subscriber Name"
								class="mb-3"
								label-for="subscriberNameInfo"
								:state="subscriberNameState"
							>
								<b-form-input
									id="subscriberNameInfo"
									placeholder="Ex: JOHN DOE"
									:state="subscriberNameState"
									v-model="addSubscriberForm.subscriberNameInfo"
									trim
								></b-form-input>
								<b-form-invalid-feedback :state="subscriberNameState">
									Please enter a valid subscriber name.
								</b-form-invalid-feedback>
							</b-input-group>

							<b-input-group
								prepend="HSS Profile"
								class="mb-3"
								label-for="hssProfileInfo"
								:state="hssProfileState"
							>
								<b-form-select
									id="hssProfileInfo"
									v-model="addSubscriberForm.hssProfileInfo"
									:options="hssProfileOption"
									:state="hssProfileState"
									value-field="key"
									text-field="value"
									size="md"
									disabled-field="notEnabled"
								>
								</b-form-select>
								<b-form-invalid-feedback :state="hssProfileState">
									Please enter a valid HSS Profile.
								</b-form-invalid-feedback>
							</b-input-group>

							<b-input-group
								prepend="HLR Profile"
								class="mb-3"
								label-for="hlrProfileInfo"
								:state="hlrProfileState"
							>
								<b-form-select
									id="hlrProfileInfo"
									v-model="addSubscriberForm.hlrProfileInfo"
									:options="hlrProfileOption"
									:state="hlrProfileState"
									value-field="key"
									text-field="value"
									size="md"
									disabled-field="notEnabled"
								>
								</b-form-select>
								<b-form-invalid-feedback :state="hlrProfileState">
									Please enter a valid HLR Profile.
								</b-form-invalid-feedback>
							</b-input-group>

							<b-input-group
								v-if="hasDataPlans"
								prepend="Data Plan"
								class="mb-3"
								label-for="dataPlanInfo"
								:state="dataPlanState"
							>
								<b-form-select
									id="dataPlanInfo"
									v-model="addSubscriberForm.dataPlanInfo"
									:options="dataPlanOption"
									:state="dataPlanState"
									value-field="key"
									text-field="value"
									size="md"
									disabled-field="notEnabled"
								>
								</b-form-select>
								<b-form-invalid-feedback :state="dataPlanState">
									Please enter a valid Data Plan.
								</b-form-invalid-feedback>
							</b-input-group>
						</b-col>
					</b-row>
					<div class="text-center" v-if="!hasMin">
						<base-button type="primary" title="Set Voice Defaults" v-on:click="setVoiceDefaults()">
							Set Voice Defaults
						</base-button>
						<base-button type="primary" title="Set Data Defaults" v-on:click="setDataDefaults()">
							Set Data Defaults
						</base-button>
						<base-button type="primary" title="Select All" v-on:click="selectAll()">
							Select All
						</base-button>
						<base-button type="primary" title="Clear All" v-on:click="clearAll()"> Clear All</base-button>
					</div>
				</b-card-body>
			</b-card>

			<b-card v-if="!hasMin">
				<b-card-header class="pt-0">
					<span class="h3">Call Forwarding</span>
				</b-card-header>
				<b-card-body class="pb-0">
					<div class="table-responsive">
						<table class="table call-forwarding-table">
							<thead>
								<tr>
									<th scope="col">Service</th>
									<th scope="col">Provisioned</th>
									<th scope="col">Number</th>
									<th scope="col">Active</th>
								</tr>
							</thead>
							<tbody>
								<tr>
									<td>
										<label for="cfu_profile_status">Unconditional</label>
									</td>

									<td>
										<b-form-checkbox
											id="cfu_profile_status"
											v-model="addSubscriberForm.unconditionalProvision"
											name="unconditionalProvision"
											value="1"
											unchecked-value="0"
										>
										</b-form-checkbox>
									</td>

									<td>
										<b-form-input
											v-model="addSubscriberForm.unconditionalNumber"
											placeholder="Ex: 19205551234"
										></b-form-input>
									</td>

									<td>
										<b-form-checkbox
											v-model="addSubscriberForm.unconditionalActive"
											name="unconditionalActive"
											value="1"
											unchecked-value="0"
										>
										</b-form-checkbox>
									</td>
								</tr>

								<tr>
									<td>
										<label for="notAvailableId">Not Available</label>
									</td>

									<td>
										<b-form-checkbox
											id="notAvailableId"
											v-model="addSubscriberForm.notAvailableProvision"
											name="notAvailableProvision"
											value="1"
											unchecked-value="0"
										>
										</b-form-checkbox>
									</td>

									<td>
										<b-form-input
											v-model="addSubscriberForm.notAvailableNumber"
											placeholder="Ex: 19205551234"
										></b-form-input>
									</td>

									<td>
										<b-form-checkbox
											v-model="addSubscriberForm.notAvailableActive"
											name="notAvailableActive"
											value="1"
											unchecked-value="0"
										>
										</b-form-checkbox>
									</td>
								</tr>

								<tr>
									<td>
										<label for="busyId">Busy</label>
									</td>

									<td>
										<b-form-checkbox
											id="busyId"
											v-model="addSubscriberForm.busyProvision"
											name="busyProvision"
											value="1"
											unchecked-value="0"
										>
										</b-form-checkbox>
									</td>

									<td>
										<b-form-input
											v-model="addSubscriberForm.busyNumber"
											placeholder="Ex: 19205551234"
										></b-form-input>
									</td>

									<td>
										<b-form-checkbox
											v-model="addSubscriberForm.busyActive"
											name="busyActive"
											value="1"
											unchecked-value="0"
										>
										</b-form-checkbox>
									</td>
								</tr>

								<tr>
									<td>
										<label for="notReachableId">Not Reachable</label>
									</td>

									<td>
										<b-form-checkbox
											id="notReachableId"
											v-model="addSubscriberForm.notReachableProvision"
											name="notReachableProvision"
											value="1"
											unchecked-value="0"
										>
										</b-form-checkbox>
									</td>

									<td>
										<b-form-input
											v-model="addSubscriberForm.notReachableNumber"
											placeholder="Ex: 19205551234"
										></b-form-input>
									</td>

									<td>
										<b-form-checkbox
											v-model="addSubscriberForm.notReachableActive"
											name="notReachableActive"
											value="1"
											unchecked-value="0"
										>
										</b-form-checkbox>
									</td>
								</tr>
							</tbody>
						</table>
					</div>
				</b-card-body>
			</b-card>

			<b-card v-if="!hasMin">
				<b-card-header class="pt-0">
					<span class="h3">Other</span>
				</b-card-header>
				<b-card-body class="pb-0">
					<b-form-checkbox v-model="addSubscriberForm.callWaiting" name="" value="1" unchecked-value="0">
						Call Waiting
					</b-form-checkbox>
					<b-form-checkbox v-model="addSubscriberForm.sms" name="" value="1" unchecked-value="0">
						SMS
					</b-form-checkbox>
					<b-form-checkbox
						v-if="!hasNsim"
						v-model="addSubscriberForm.enableData"
						name=""
						value="1"
						unchecked-value="0"
						@change="enableDataStatusChange()"
					>
						Enable Data
						<span v-if="!enableDataStatus" class="bg-yellow"
							>Warning: Unchecking this will prevent data usage towers!</span
						>
					</b-form-checkbox>
					<b-form-checkbox
						v-model="addSubscriberForm.localData"
						name=""
						value="1"
						unchecked-value="0"
						v-if="has_local_data"
						@change="localDataStatusChange()"
					>
						Local Data (no roaming)
						<span class="bg-yellow" v-if="localDataStatus">
							Warning: This will only allow uses to use data on local towers!</span
						>
					</b-form-checkbox>
					<b-form-checkbox v-model="addSubscriberForm.callerId" name="" value="1" unchecked-value="0">
						Caller ID
					</b-form-checkbox>
					<b-form-checkbox v-model="addSubscriberForm.mms" name="" value="1" unchecked-value="0">
						MMS
					</b-form-checkbox>
					<b-form-checkbox
						v-model="addSubscriberForm.clip_profile_status"
						name=""
						value="1"
						unchecked-value="0"
					>
						Clip
					</b-form-checkbox>
					<b-form-checkbox
						v-if="hasNsim"
						v-model="addSubscriberForm.enableData"
						name=""
						value="1"
						unchecked-value="0"
					>
						2G/3G Data
					</b-form-checkbox>
					<b-form-checkbox
						v-if="hasNsim"
						v-model="addSubscriberForm.lte"
						name=""
						value="1"
						unchecked-value="0"
					>
						LTE Data
					</b-form-checkbox>
					<b-form-checkbox
						v-if="hasNetlink"
						v-model="addSubscriberForm.voLte"
						name=""
						value="1"
						unchecked-value="0"
					>
						VoLTE
					</b-form-checkbox>
					<b-form-checkbox
						v-if="hasNetlink"
						v-model="addSubscriberForm.voWifi"
						name=""
						value="1"
						unchecked-value="0"
					>
						VoWIFI
					</b-form-checkbox>
					<b-form-checkbox
						v-if="isNsim"
						v-model="addSubscriberForm.tis"
						name=""
						value="1"
						unchecked-value="0"
					>
						International Roaming Data
					</b-form-checkbox>
				</b-card-body>
			</b-card>
			<hr />
			<b-row class="mt-3">
				<b-col xl="6" md="6" sm="6">
					<div class="float-left">
						<base-button type="light" title="Close" v-on:click="modalClose()"> Close</base-button>
					</div>
				</b-col>
				<b-col xl="6" md="6" sm="6">
					<div class="float-right">
						<base-button type="primary" title="Submit" v-on:click="activateSubscriberSubmit">
							Submit
						</base-button>
					</div>
				</b-col>
			</b-row>
		</b-form>
		<!--no-close-on-backdrop-->
		<b-modal centered size="sm" id="activity_progress_bar" hide-footer hide-header class="activity_progress_bar">
			<p class="h1 text-center mb-4">Activity</p>
			<b-progress
				:value="progressStartValue"
				height="16px"
				variant="primary"
				:striped="true"
				class="mt-2"
				:animated="true"
				show-progress
			></b-progress>
			<div class="text-center">
				<small class="text-center" v-if="progressTitle">{{ progressTitle }}</small>
				<br />
				<small class="text-center" v-if="progressMessage">{{ progressMessage }}</small>
			</div>
		</b-modal>
	</div>
</template>

<script>
import searchDashboardService from "../../common/api-services/search-dashboard-service";
import configDirective from "../../common/directive/config-directive";
import provisioningService from "../../common/api-services/provisioning-service";
import commonService from "../../common/api-services/common";
import ToastVue from "./Toast.vue";
import AuthService from "../../common/api-services/auth-service";

export default {
	name: "Activate-Subscriber",
	components: {ToastVue},
	computed: {
		//validators https://www.npmjs.com/package/node-input-validator or https://express-validator.github.io/docs/
		//https://regex101.com/codegen?language=javascript
		iccidState() {
			return commonService.validationCheck("ICCID", this.addSubscriberForm.iccidInfo);
		},
		imsiState() {
			return commonService.validationCheck("IMSI", this.addSubscriberForm.imsiInfo);
		},
		msisdnState() {
			return commonService.validationCheck("MSISDN", this.addSubscriberForm.msisdnInfo);
		},
		minState() {
			return commonService.validationCheck("MIN", this.addSubscriberForm.minInfo);
		},
		// subscriberNameState() {
		//   this.addSubscriberForm.subscriberNameInfo = this.addSubscriberForm.subscriberNameInfo.replace(/[^\w]/gmi, "_");
		//   return (this.addSubscriberForm.subscriberNameInfo.length > 3 && this.addSubscriberForm.subscriberNameInfo.length < 51);
		//   //return commonService.validationCheck('SUBSCRIBERNAME', this.addSubscriberForm.subscriberNameInfo);
		// },
		subscriberNameState() {
			let validatedName = this.addSubscriberForm.subscriberNameInfo.replace(/[^\w]/gim, "_");
			return validatedName.length > 3 && validatedName.length < 51;
			//return commonService.validationCheck('SUBSCRIBERNAME', this.addSubscriberForm.subscriberNameInfo);
		},
		hssProfileState() {
			return commonService.validationCheck("HSSPROFILE", this.addSubscriberForm.hssProfileInfo);
		},
		hlrProfileState() {
			return commonService.validationCheck("HLRPROFILE", this.addSubscriberForm.hlrProfileInfo);
		},
		dataPlanState() {
			return commonService.validationCheck("DATAPLAN", this.addSubscriberForm.dataPlanInfo);
		},
	},

	data() {
		return {
			lastMessage: "",
			progressStartValue: 5,
			hasDataPlans: true,
			hasMin: false,
			isNsim: false,
			hasNsim: false,
			hasNetlink: false,
			addSubscriberForm: {
				minInfo: "",
				iccidInfo: "",
				imsiInfo: "",
				msisdnInfo: "",
				subscriberNameInfo: "",
				hssProfileInfo: "",
				hlrProfileInfo: "",
				dataPlanInfo: "",
				unconditionalProvision: "0",
				unconditionalActive: "0",
				unconditionalNumber: "",
				notAvailableProvision: "0",
				notAvailableActive: "0",
				notAvailableNumber: "",
				busyProvision: "0",
				busyActive: "0",
				busyNumber: "",
				notReachableProvision: "0",
				notReachableActive: "0",
				notReachableNumber: "",
				clip_profile_status: "",
				callWaiting: "0",
				sms: "0",
				enableData: "1",
				localData: "0",
				callerId: "1",
				mms: "1",
				tis: "0",
				lte: "1",
				voLte: "1",
				voWifi: "1",
			},
			has_local_data: false,
			enableDataStatus: false,
			localDataStatus: false,
			hssProfileOption: [],
			hlrProfileOption: [],
			dataPlanOption: [],
			timer: null,
			progressTitle: null,
			progressMessage: null,
		};
	},

	watch: {
		//    addSubscriberForm.subscriberNameInfo: function = this.addSubscriberForm.subscriberNameInfo.replace(/[^\w]/gmi, "_");//.replaceAll('__','_').replaceAll('__','_').replaceAll('__','_').replaceAll('__','_');
	},

	mounted() {
		//this.$bvModal.show('activity_progress_bar');

		//hide local data
		if (configDirective.getConfigData()["site-settings"]["has_local_data"]) {
			if (process.env.NODE_ENV === "dev")
				console.log("has local data:", configDirective.getConfigData()["site-settings"]["has_local_data"]);
			this.has_local_data = true;
		}

		this.hasDataPlans = configDirective.hasDataPlans();
		this.hasNsim = configDirective.hasNsim();
		this.hasNetlink = configDirective.hasNetlink();
		this.hasMin = configDirective.hasMin();

		this.setProgressTimer();

		this.getDefaultCFNumberFunc();

		this.$root.$on("sendIsNsimStatus", isNsim => {
			// console.log("isNsim", isNsim);
			this.isNsim = isNsim;
		});

		this.$root.$on("sendHasMinStatus", hasMin => {
			this.hasMin = hasMin;
		});

		this.$root.$on("sendIMSIInfo", imsi => {
			this.addSubscriberForm.imsiInfo = imsi;

			this.getHssProfiles();
			this.getHlrProfiles();
			if (this.hasDataPlans) {
				this.getDataPlans();
			}
			// this can come from the parent controller/container. No need to requery.
			//this.getSubscriberData();
		});

		this.$root.$on("sendICCIDInfo", iccid => {
			this.addSubscriberForm.iccidInfo = iccid;
		});
	},

	beforeDestroy() {
		clearInterval(this.timer);
		this.timer = null;
	},

	methods: {
		validateData() {
			let errors = [];
			if (!commonService.validationCheck("ICCID", this.addSubscriberForm.iccidInfo)) errors.push("INVALID ICCID");
			if (!commonService.validationCheck("IMSI", this.addSubscriberForm.imsiInfo)) errors.push("INVALID IMSI");
			if (!commonService.validationCheck("MSISDN", this.addSubscriberForm.msisdnInfo))
				errors.push("INVALID MSISDN");
			this.addSubscriberForm.subscriberNameInfo = this.addSubscriberForm.subscriberNameInfo.replace(
				/[^\w]/gim,
				"_"
			);
			if (!commonService.validationCheck("SUBSCRIBERNAME", this.addSubscriberForm.subscriberNameInfo))
				errors.push("INVALID SUBSCRIBERNAME");
			if (!commonService.validationCheck("HSSPROFILE", this.addSubscriberForm.hssProfileInfo))
				errors.push("INVALID HSSPROFILE");
			if (!commonService.validationCheck("HLRPROFILE", this.addSubscriberForm.hlrProfileInfo))
				errors.push("INVALID HLRPROFILE");
			if (this.hasDataPlans && !commonService.validationCheck("DATAPLAN", this.addSubscriberForm.dataPlanInfo))
				errors.push("INVALID DATAPLAN");

			return errors;
		},

		setProgressTimer() {
			this.timer = setInterval(() => {
				this.progressStartValue = this.progressStartValue + (Math.random() * 300) / this.progressStartValue;
				if (this.progressStartValue > 100) {
					this.progressStartValue = 10;
				}
			}, 1000);
		},

		getDefaultCFNumberFunc() {
			let dfNum = configDirective.getDefaultCFNumber();
			this.addSubscriberForm.unconditionalNumber = dfNum;
			this.addSubscriberForm.notAvailableNumber = dfNum;
			this.addSubscriberForm.busyNumber = dfNum;
			this.addSubscriberForm.notReachableNumber = dfNum;
		},

		//getSubscriberData() {
		// searchDashboardService.getLookupSubscriber(this.addSubscriberForm.imsiInfo).then(res => {
		//   if (res && res.success) {
		//     let data = res['success']['results'][0];
		//     this.addSubscriberForm.iccidInfo = data['ICCID'];
		//     this.addSubscriberForm.msisdnInfo = data['MSISDN'];
		//     // this.addSubscriberForm.subscriberNameInfo = data['Subscriber_Name'];
		//     // this.addSubscriberForm.hssProfileInfo = data['HSS_Profile'];
		//     // this.addSubscriberForm.hlrProfileInfo = data['HLR_Profile'];
		//     // this.addSubscriberForm.dataPlanInfo = data['Data'];
		//     // this.addSubscriberForm.unconditionalProvision = data['CFU_Provisioned'] === 'Yes' ? '1' : '0';
		//     // this.addSubscriberForm.unconditionalNumber = data['CFU_Number'] === '' ? this.addSubscriberForm.unconditionalNumber : data['CFU_Number'];
		//     // this.addSubscriberForm.unconditionalActive = data['CFU_Active'] === 'Yes' ? '1' : '0';
		//     // this.addSubscriberForm.notAvailableProvision = data['CFNA_Provisioned'] === 'Yes' ? '1' : '0';
		//     // this.addSubscriberForm.notAvailableNumber = data['CFNR_Number'] === '' ? this.addSubscriberForm.notAvailableNumber : data['CFNR_Number'];
		//     // this.addSubscriberForm.notAvailableActive = data['CFNR_Active'] === 'Yes' ? '1' : '0';
		//     // this.addSubscriberForm.busyProvision = data['CFB_Provisioned'] === 'Yes' ? '1' : '0';
		//     // this.addSubscriberForm.busyNumber = data['CFB_Number'] === '' ? this.addSubscriberForm.busyNumber : data['CFB_Number'];
		//     // this.addSubscriberForm.busyActive = data['CFB_Active'] === 'Yes' ? '1' : '0';
		//     // this.addSubscriberForm.notReachableProvision = data['CFNR_Provisioned'] === 'Yes' ? '1' : '0';
		//     // this.addSubscriberForm.notReachableNumber = data['CFNR_Number'] === '' ? this.addSubscriberForm.notReachableNumber : data['CFNR_Number'];
		//     // this.addSubscriberForm.notReachableActive = data['CFNR_Active'] === 'Yes' ? '1' : '0';
		//     // this.addSubscriberForm.callWaiting = data['Call_Waiting'] === 'Yes' ? '1' : '0';
		//     // this.addSubscriberForm.sms = data['SMS'] === 'Yes' ? '1' : '0';
		//     // this.addSubscriberForm.enableData = data['Data'] === 'Yes' ? '1' : '0';
		//     // this.addSubscriberForm.localData = data['LocaDataOnly'] === 'Yes' ? '1' : '0';
		//     // this.addSubscriberForm.callerId = data['Clip'] === 'Yes' ? '1' : '0';
		//     // this.addSubscriberForm.mms = data['MMS'] === 'Yes' ? '1' : '0';
		//     // this.enableDataStatus = this.addSubscriberForm.enableData === 'Yes';
		//     // this.localDataStatus = this.addSubscriberForm.localData === 'Yes';
		//    this.$bvModal.hide('activity_progress_bar');
		// }
		// })
		//},

		getHssProfiles() {
			let items = [];
			items.push({key: "", value: "Not Set"});
			searchDashboardService.getHSSProfileSelectOption().then(res1 => {
				if (res1.results) {
					res1["results"]["list-item"].map(item => {
						if (item.name !== "") items.push({key: item.name, value: item.name});
					});
					this.hssProfileOption = items;
				}
			});
			if (items.length > 1 && items[1].key.toLowerCase() === "default") {
				this.addSubscriberForm.hssProfileInfo = items[1].key;
			} else {
				this.addSubscriberForm.hssProfileInfo = items[0].key;
			}
		},

		getHlrProfiles() {
			let items = [];
			items.push({key: "", value: "Not Set"});
			searchDashboardService.getHlrProfileSelectOption().then(res1 => {
				res1.map(item => {
					if (item.product !== "") items.push({key: item.product, value: item.description});
				});
				this.hlrProfileOption = items;
			});
			if (items.length > 1 && items[1].key.toLowerCase() === "default") {
				this.addSubscriberForm.hlrProfileInfo = items[1].key;
			} else {
				this.addSubscriberForm.hlrProfileInfo = items[0].key;
			}
		},

		getDataPlans() {
			let items = [];
			items.push({key: "", value: "Not Set"});
			searchDashboardService.getDataBucketList("default").then(res => {
				// console.log("DATA PLANS:", res);
				res.map(item => {
					if (item.value.split("default_")[1]) {
						items.push({value: item.value.split("default_")[1] + " : " + item.text, key: item.value});
					} else {
						items.push({value: item.text, key: item.value});
					}
				});
				this.dataPlanOption = items;
			});
			this.addSubscriberForm.dataPlanInfo = items[0].key;
		},

		setVoiceDefaults() {
			this.clearAll();
			this.addSubscriberForm.unconditionalProvision = "1";
			this.addSubscriberForm.notAvailableProvision = "1";
			this.addSubscriberForm.notAvailableActive = "1";
			this.addSubscriberForm.busyProvision = "1";
			this.addSubscriberForm.busyActive = "1";
			this.addSubscriberForm.notReachableProvision = "1";
			this.addSubscriberForm.notReachableActive = "1";
			this.addSubscriberForm.callWaiting = "1";
			this.addSubscriberForm.sms = "1";
			this.addSubscriberForm.callerId = "1";
			this.addSubscriberForm.mms = "1";
			this.addSubscriberForm.clip_profile_status = "1";
		},

		setDataDefaults() {
			this.clearAll();

			this.addSubscriberForm.enableData = "1";

			if (this.hasNsim) {
				this.addSubscriberForm.lte = "1";
				if (this.isNsim) {
					this.addSubscriberForm.tis = "1";
				}
			}
		},

		selectAll() {
			this.clearAll();
			this.addSubscriberForm.unconditionalProvision = "1";
			this.addSubscriberForm.notAvailableProvision = "1";
			this.addSubscriberForm.notAvailableActive = "1";
			this.addSubscriberForm.busyProvision = "1";
			this.addSubscriberForm.busyActive = "1";
			this.addSubscriberForm.notReachableProvision = "1";
			this.addSubscriberForm.notReachableActive = "1";
			this.addSubscriberForm.callWaiting = "1";
			this.addSubscriberForm.sms = "1";
			this.addSubscriberForm.enableData = "1";
			this.addSubscriberForm.callerId = "1";
			this.addSubscriberForm.mms = "1";
			this.addSubscriberForm.clip_profile_status = "1";
			if (this.hasNetlink) {
				this.addSubscriberForm.voWifi = "1";
				this.addSubscriberForm.voLte = "1";
			}
			if (this.hasNsim) {
				// this.addSubscriberForm.enableData = "1";
				this.addSubscriberForm.lte = "1";
				if (this.isNsim) {
					this.addSubscriberForm.tis = "1";
				}
			}
		},

		clearAll() {
			this.addSubscriberForm.unconditionalProvision = "0";
			this.addSubscriberForm.unconditionalActive = "0";
			this.addSubscriberForm.notAvailableProvision = "0";
			this.addSubscriberForm.notAvailableActive = "0";
			this.addSubscriberForm.busyProvision = "0";
			this.addSubscriberForm.busyActive = "0";
			this.addSubscriberForm.notReachableProvision = "0";
			this.addSubscriberForm.notReachableActive = "0";
			this.addSubscriberForm.callWaiting = "0";
			this.addSubscriberForm.sms = "0";
			this.addSubscriberForm.enableData = "0";
			this.addSubscriberForm.localData = "0";
			this.addSubscriberForm.callerId = "0";
			this.addSubscriberForm.mms = "0";
			this.addSubscriberForm.clip_profile_status = "0";
			if (this.hasNetlink) {
				this.addSubscriberForm.voWifi = "0";
				this.addSubscriberForm.voLte = "0";
			}
			if (this.hasNsim) {
				// this.addSubscriberForm.enableData = "0";
				this.addSubscriberForm.lte = "0";
				if (this.isNsim) {
					this.addSubscriberForm.tis = "0";
				}
			}
		},

		activateSubscriberSubmit() {
			// console.log("addSubscriberForm:", this.addSubscriberForm);

			this.errors = this.validateData();
			if (this.errors && this.errors.length > 0) {
				commonService.showToast("Validation Errors", this.errors.join("<br>"));
				return;
			}

			//this.$root.$emit('setSimStatus', 'Pending');
			this.$bvModal.show("activity_progress_bar");
			this.progressTitle = "Processing Actions";
			this.progressMessage = "Adding Subscriber...";
			this.setProgressTimer();

			provisioningService
				.submitAddSubscriber(this.addSubscriberForm)
				.then(queueid => {
					//if (process.env.NODE_ENV === 'dev')
					console.warn("[DEBUG][SimDetail.vue] submitActivateSubscriber.queueid:", queueid);
					if (typeof queueid === "undefined") throw new Error("ACTIVATE ACTION FAILED.");
					if (!configDirective.hasPolling()) {
						if (
							JSON.stringify(queueid).toLowerCase().includes("error") ||
							JSON.stringify(queueid).toLowerCase().includes("fail")
						)
							throw new Error(JSON.stringify(queueid));
						this.$toast.success({
							component: ToastVue,
							props: {
								title: "Activate Subscriber",
								subtitle: "The SIM was activated successfully and is now available for reuse.",
								//description: JSON.stringify(queueid)
							},
						});
						this.closeModal();
					} else {
						provisioningService
							.getPollUntilDone(queueid, 60000, 1000, this.processMessage)
							.then(response => {
								if (process.env.NODE_ENV === "dev")
									console.warn(
										"[DEBUG][submitActivateSubscriber] getPollUntilDone.response:",
										response
									);
								if (response.status && response.status === "DONE") {
									this.processMessage(response);
								}
							})
							.catch(e => {
								// console.error('ACTIVATE ERROR OCCURRED-1',e);
								let msg = [];
								msg.status = "ERROR";
								msg.details = e.toString();
								this.processMessage(msg);
							});
					}
				})
				.catch(e => {
					//cleanup by terminating the imsi by default;
					provisioningService.submitTerminateSubscriber(this.addSubscriberForm.imsiInfo);
					console.error("ACTIVATE ERROR OCCURRED-2", e);
					this.$toast.error({
						component: ToastVue,
						props: {
							title: "Activate Subscriber",
							subtitle:
								"There was an error activating the SIM.  Please try again or refer to the logs for more details.",
							description: e.toString(),
						},
					});
					this.closeModal();
				});
		},

		//TODO finish processing all JSON from output - Use common json2html
		async processMessage(msg) {
			if (!msg || String(msg).length < 5) return;
			if (JSON.stringify(this.lastMessage) === JSON.stringify(msg)) return;
			if (process.env.NODE_ENV === "dev") console.log("processMessage.ACTIVATE:", msg);

			if (
				JSON.stringify(msg).toLowerCase().includes("error") ||
				JSON.stringify(msg).toLowerCase().includes("fail")
			) {
				if (process.env.NODE_ENV === "dev")
					console.log("processMessage found error or fail in msg:" + JSON.stringify(msg).toLowerCase());
				msg.status = "ERROR";
			}

			if (msg.response)
				if (msg.status === "DONE" || msg.status === "ERROR") {
					this.addLog(msg.response, msg.status === "ERROR" ? 1 : 0);
					let messageData = "";
					if (msg && msg.response) {
						try {
							let j = JSON.parse(msg.response);
							if (j.success) {
								//console.log('s:', j.success);
								j.success.map(item => {
									messageData =
										messageData +
										item
											.replaceAll('"', "")
											.replaceAll("{", "")
											.replaceAll("}", "")
											.replaceAll("[", "")
											.replaceAll("]", "")
											.replaceAll('"', "")
											.replaceAll('"', "") +
										`<br>`;
								});
							}
							if (j.error) {
								// console.log('j.error:', j.error);
								j.error.map(item => {
									messageData = item + `<br>`;
								});
							}
						} catch (e) {
							console.error(e);
						} //ignore
					}

					if (process.env.NODE_ENV === "dev") {
						console.log("processMessage.msg:", msg);
						console.log("processMessage.STATUS:", msg.status);
						console.log("processMessage.messageData:", messageData);
					}

					if (msg.status === "ERROR") {
						if (typeof msg.details !== "undefined") {
							// this.addLog(messageData, 1)
							this.$toast.error(
								{
									component: ToastVue,
									props: {
										title: "Activate Subscriber",
										subtitle:
											"There was an error activating the SIM for use.  Please try again or refer to the logs for more details.",
										description: JSON.stringify(messageData),
									},
								},
								{
									timeout: 45000,
								}
							);
						} else {
							// this.addLog(messageData, 1)
							this.$toast.error(
								{
									component: ToastVue,
									props: {
										title: "Activate Subscriber",
										subtitle:
											"There was an error activating the SIM for use.  Please try again or refer to the logs for more details.",
										description: JSON.stringify(messageData),
									},
								},
								{
									timeout: 45000,
								}
							);
						}
					} else {
						// this.addLog(messageData, 0)
						this.$toast.success({
							component: ToastVue,
							props: {
								title: "Activate Subscriber",
								subtitle: "The SIM was activated successfully and is now available for use.",
								description: JSON.stringify(messageData),
							},
						});
					}
					this.closeModal();
				} else {
					this.progressMessage = msg.status;
				}
			this.lastMessage = msg;
		},

		addLog(details, isError = 0) {
			AuthService.setActivityLog("Mobility: Activate Subscriber", details, isError);
		},

		closeModal() {
			setTimeout(() => {
				this.progressMessage = "Refreshing Subscriber data...";

				//window.location.reload();
				this.$forceUpdate();

				this.$root.$emit("reloadSimDetailPageData", this.addSubscriberForm.imsiInfo);
				this.$bvModal.hide("activity_progress_bar");
				this.$bvModal.hide("activate-subscriber");
			}, 1000);
		},

		enableDataStatusChange() {
			this.enableDataStatus = this.enableDataStatus !== true;
		},

		localDataStatusChange() {
			this.localDataStatus = this.localDataStatus !== true;
		},

		modalClose() {
			this.$bvModal.hide("activate-subscriber");
		},
	},
};
</script>
